import { withStyles } from '@material-ui/core';

import Tag from './component';
import styles from './styles';

export default withStyles(styles)(Tag);
